import type { Listing } from '../types'

// Всё время в магазине московское, и показываем мы его же.
const MOSCOW = 'Europe/Moscow'

const fmt = (opts: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat('ru-RU', { timeZone: MOSCOW, ...opts })

export function time(iso: string | null | undefined): string {
  if (!iso) return 'сразу'
  return fmt({ hour: '2-digit', minute: '2-digit' }).format(new Date(iso))
}

// Заголовок группы в расписании: «Сегодня», «Завтра» или «15 сентября».
export function dayLabel(iso: string | null | undefined): string {
  if (!iso) return 'Как можно скорее'
  const day = (d: Date) => fmt({ year: 'numeric', month: '2-digit', day: '2-digit' }).format(d)
  const now = new Date()
  const tomorrow = new Date(now.getTime() + 24 * 3600 * 1000)
  const target = new Date(iso)
  if (day(target) === day(now)) return 'Сегодня'
  if (day(target) === day(tomorrow)) return 'Завтра'
  return fmt({ day: 'numeric', month: 'long' }).format(target)
}

// Значение для <input type="datetime-local">: московское время без зоны.
export function localInput(date: Date): string {
  const parts = new Intl.DateTimeFormat('sv-SE', {
    timeZone: MOSCOW,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date)
  const get = (t: Intl.DateTimeFormatPartTypes) => {
    const part = parts.find((p) => p.type === t)
    if (!part) throw new Error(`Intl не вернул часть даты «${t}»`)
    return part.value
  }
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`
}

export const STATES: Record<string, string> = {
  planned: 'запланировано',
  queued: 'в очереди',
  running: 'выкладывается',
  drafted: 'черновик готов',
  published: 'опубликовано',
  failed: 'не вышло',
  cancelled: 'снято',
}

export function money(value: number | null | undefined): string {
  return value ? `${value.toLocaleString('ru-RU')} ₽` : 'без цены'
}

export interface DayGroup {
  label: string
  rows: Listing[]
}

// Группировка расписания по дням с сохранением порядка.
export function byDay(rows: Listing[]): DayGroup[] {
  const groups: DayGroup[] = []
  for (const row of rows) {
    const label = dayLabel(row.publish_at)
    const last = groups[groups.length - 1]
    if (last && last.label === label) last.rows.push(row)
    else groups.push({ label, rows: [row] })
  }
  return groups
}
